import React, { useContext } from "react";
import { I18nContext } from "../../i18n";
import { Navbar, Nav, Row, Col } from "react-bootstrap";
import LanguageSelect from "./LanguageSelect";
import { Link } from "react-router-dom";
import Icons from "../../scss/prh-icon-sprite.svg";

const NavMenu = ( props ) => {
  const { translate } = useContext(I18nContext);

  return (
    <div>
      <Link to={ props.pathParams.buildPath() }>
        <Row className="pt-3 pb-3">
          <Col className="ml-3">
            <svg
              alt={translate("trademark_navigation_home")}
              className="prh-icon prh-icon--xs stroke-white"
            >
              <use xlinkHref={`${Icons}#home`}></use>
            </svg>
            <span className="menu-text ml-1" data-cy="home">
              {translate("trademark_frontpage")}
            </span>
          </Col>
        </Row>
      </Link>
      <Link to={ props.pathParams.buildPath( 'search' )}>
        <Row className="pt-3 pb-3">
          <Col className="">
            <span className="menu-text" data-cy="search">
              {translate("trademark.portlet.advanced.search")}
            </span>
          </Col>
        </Row>
      </Link>
      <Link to={ props.pathParams.buildPath( 'tmr' )}>
        <Row className="pt-3 pb-3">
          <Col>
            <span className="menu-text" data-cy="known_tm">
              {translate("menu_known_trademarks")}
            </span>
          </Col>
        </Row>
      </Link>
      <a href={translate("navbar_tmgazette_extlink")}>
        <Row className="pt-3 pb-3">
          <Col className="ml-3">
            <svg
              aria-labelledby="gazette_link"
              className="prh-icon prh-icon--xs stroke-white"
            >
              <title id="gazette_link">
                {translate("trademark_external_link")}
              </title>
              <use xlinkHref={`${Icons}#external-link`}></use>
            </svg>
            <span className="menu-text ml-1" data-cy="tabs">
              {translate("menu_tabs")}
            </span>
          </Col>
        </Row>
      </a>
      <a href={translate("navbar_searchinstructions_extlink")}>
        <Row className="pt-3 pb-3">
          <Col className="ml-3">
            <svg
              aria-labelledby="instructions_link"
              className="prh-icon prh-icon--xs stroke-white"
            >
              <title id="instructions_link">
                {translate("trademark_external_link")}
              </title>
              <use xlinkHref={`${Icons}#external-link`}></use>
            </svg>
            <span className="menu-text ml-1" data-cy="instructions">
              {translate("menu_instructions")}
            </span>
          </Col>
        </Row>
      </a>
      <Navbar className="navbar navbar-dark navbar-expand-md">
        <Nav>
          <LanguageSelect pathParams = { props.pathParams }/>
        </Nav>
      </Navbar>
    </div>
  );
};

export default NavMenu;
